import Circle from "./SVG/circle.svg?react";

const CircleIcon = () => {
  return <Circle />;
};

export default CircleIcon;
